class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close(true, 'escape_key', 'cancel');
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', () => {
        const elementId = button.dataset.analyticsElementId ||
          (button.classList.contains('modal-overlay') ? 'backdrop' : 'close_button');
        this.close(true, elementId, 'cancel');
      });
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close(true, this.summaryToggle.dataset.analyticsElementId || 'toggle', 'cancel')
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false, 'backdrop', 'cancel');
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    this.trackAnalyticsLifecycle(
      'open',
      event?.target?.closest?.('summary')?.dataset?.analyticsElementId ||
        this.dataset.analyticsOpenElementId ||
        'auto_open',
      'success'
    );
  }

  close(focusToggle = true, analyticsElementId = 'programmatic_close', analyticsResult = 'cancel') {
    const wasOpen = this.isOpen();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (wasOpen) this.trackAnalyticsLifecycle('close', analyticsElementId, analyticsResult);
  }

  trackAnalyticsLifecycle(interactionName, elementId, interactionResult) {
    if (!this.hasAttribute('data-analytics-modal-lifecycle')) return;
    window.TorrasAnalytics?.trackInteraction(this, {
      componentId: this.dataset.analyticsComponentId,
      elementType: 'component',
      elementId,
      interactionName,
      interactionResult,
    });
  }
}

customElements.define('details-modal', DetailsModal);
